import { extractPersonFromJsonLd } from './index';
export var extractPersonCreatedBy = function extractPersonCreatedBy(jsonLd) {
  var attributedTo = jsonLd.attributedTo;
  if (attributedTo) {
    if (Array.isArray(attributedTo)) {
      return attributedTo.map(extractPersonFromJsonLd).filter(function (item) {
        return !!item;
      });
    } else {
      var item = extractPersonFromJsonLd(attributedTo);
      if (item) {
        return [item];
      }
    }
  }
};